import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../filters';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from "luxon";

export default {
  name: 'empSchedule',
  components: {
    DataGridComp: require('../../customcontrols/datagrid.vue').default,
    datetime: Datetime,
    DateTime,
  },
  props: {
    applicationId: {
      type: String,
      required: true
    },
    appKey: {
      type: String,
      required: true
    },
  },
  data: function () {
    return {
      options: { pageSize: 10, filterText: '', page: 1 },
      scheduleItems: [],
      keyColumn: 'id',
      totalRow: 0,
      addingNewItem: false,
      scheduleCols: [],
      schedule: {
        id: 0,
        sourceId: this.applicationId,
        sourceSubId: 0,
        employeeId: 0,
        periodTypeId: 0,
        periodDate: new Date().toLocaleString(),
        periodBegin: new Date().toLocaleString(),
        periodEnd: new Date().toLocaleString(),
        periodType: 0,
        comment: '',
        usageTypeId: 0,
        rateTypeId: 0,
        duration: 0,
        wholeDay: false
      },
      isNewItem: true,
      showConfirmDelete: false,
      deleteMessage: '',
      perEnd: '',
      perBegining: '',
      wholeDay: false,
    }
  },
  created() {
    console.log("empl schedule data",this);
    this.getEmployeeSchedules();
    this.fillScheduleCols();    
  },
  watch: {
    perBegining: function (val) {
      this.schedule.periodBegin = this.convertDate(val);
      this.calculateDuration();
    },
    perEnd: function (val) {
      this.schedule.periodEnd = this.convertDate(val);
      this.calculateDuration();
    },
    wholeDay: function (val) {
      if (val) {
        this.perBegining = "1999-01-01T00:00:00";
        this.perEnd = "1999-01-01T00:00:00";
        this.schedule.periodBegin = "1999-01-01T00:00:00";
        this.schedule.periodEnd = "1999-01-01T00:00:00";
      } else {
        this.perBegining = "";
        this.perEnd = "";
        this.schedule.periodBegin = "";
        this.schedule.periodEnd = "";
      }
      this.schedule.duration = '0';
      this.schedule.wholeDay = val;
    }
  },
  methods: {
    convertDate(val) {

      let valDate = new Date(val);
      let perDate = new Date(this.schedule.periodDate);

      //construct final date in sql datetime format from period date base and hours from val
      let date = perDate.getFullYear() + '-' +
        ('00' + (perDate.getMonth() + 1)).slice(-2) + '-' +
        ('00' + perDate.getDate()).slice(-2) + 'T' +
        ('00' + valDate.getHours()).slice(-2) + ':' +
        ('00' + valDate.getMinutes()).slice(-2) + ':' +
        '00';

      return date;
    },
    calculateDuration() {
      //extract time build a new date
      let e = new Date(this.schedule.periodEnd);
      let st = new Date(this.schedule.periodBegin);

      let now = new Date();
      let end = now.setHours(e.getHours(), e.getMinutes());
      let start = now.setHours(st.getHours(), st.getMinutes());

      //find difference and c0nvert it to hrs
      this.schedule.duration = String(Math.floor((end - start) / 1000 / 60));
      //console.log("end", end, "start", start, this.schedule.duration);
      //error trap
      if ((this.schedule.duration < 0 || isNaN(this.schedule.duration)) && !this.wholeDay) {
        this.schedule.duration = '0';
        //this.$alertMsg(`${this.$t('messages.startEndTimeError')}`, 3);
      }

      if (this.schedule.wholeDay)
        this.schedule.periodTypeId = 2;
      else
        this.schedule.periodTypeId = 1;

      this.$forceUpdate();
    },
    getEmployeeSchedules() {
      axios.post('/Schedule/GetEmployeeSchedules', {
        sourceId: Number(this.applicationId),
        sourceSubId: 0,//Number(this.appKey),
        options: this.options
      })
        .then(response => {
          if (response.status == 200) {
            //console.log('empSeched data', response);
            response.data.items.forEach(item => {
              item.begin = moment(item.periodBegin).format('HH:mm:ss');
              item.end = moment(item.periodEnd).format('HH:mm:ss');
              item.periodDuration = Math.floor((Date.parse(item.periodEnd ) - Date.parse(item.periodBegin)) / 1000 / 60);
            });

            this.scheduleItems = response.data.items;
            this.totalRow = response.data.itemsCount;

            this.addingNewItem = false;
          } else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(error => {
          error.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${error.response.status}`) :
            this.$alertMsg(error.data.data.text);
        })
    },
    pageChange(pInfo) {
      if (pInfo.pageNumber == this.options.page && pInfo.pageSize == this.options.pageSize)
        return;

      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;

      this.getEmployeeSchedules();
    },
    selectionChanged(info) {

    },
    onRowDblClick(info) {
      if (!info.data || !info.data.id)
        return;

      this.schedule = {
        id: info.data.id,
        sourceId: info.data.sourceId,
        sourceSubId: info.data.sourceSubId,
        employeeId: info.data.employeeId,
        periodTypeId: info.data.periodTypeId,
        periodDate: info.data.periodDate,
        periodBegin: info.data.periodBegin,
        periodEnd: info.data.periodEnd,
        comment: info.data.comment,
        usageTypeId: info.data.usageTypeId,
        rateTypeId: info.data.rateTypeId,
        duration: info.data.periodDuration,
        wholeDay: info.data.periodTypeId == 2 ? true : false,
      };
     
      this.perBegining = this.schedule.periodBegin;
      this.perEnd = this.schedule.periodEnd;
      this.isNewItem = false;
      this.addingNewItem = true;

      if (this.schedule.periodTypeId == 2)
        this.schedule.wholeDay = true;
      else
        this.schedule.wholeDay = false;

      this.wholeDay = this.schedule.wholeDay;
    },
    fillScheduleCols() {
      this.scheduleCols = [];

      this.scheduleCols.push({ dataField: 'employee', name: 'employee', caption: this.$t('schedule.employee') });
      //this.scheduleCols.push({ dataField: 'orgPost', name: 'orgPost', caption: this.$t('schedule.orgPost') });
      this.scheduleCols.push({ dataField: 'usageType', name: 'usageType', caption: this.$t('schedule.usageType') });
      this.scheduleCols.push({ dataField: 'periodDate', name: 'periodDate', caption: this.$t('schedule.usageDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.scheduleCols.push({ dataField: 'periodType', name: 'periodType', caption: this.$t('schedule.periodType') });
      this.scheduleCols.push({ dataField: 'begin', name: 'begin', caption: this.$t('schedule.begin'), dataType: 'string' });
      this.scheduleCols.push({ dataField: 'end', name: 'end', caption: this.$t('schedule.end'), dataType: 'string' });
      this.scheduleCols.push({ dataField: 'periodDuration', name: 'periodDuration', caption: this.$t('schedule.duration'), dataType: 'string' });
      this.scheduleCols.push({ dataField: 'rateType', name: 'rateType', caption: this.$t('schedule.rateType') });
      this.scheduleCols.push({ dataField: 'comment', name: 'comment', caption: this.$t('schedule.comment') });
    },
    addNewItem() {
      this.schedule = {
        id: 0,
        sourceId: this.applicationId,
        sourceSubId: 0,
        employeeId: -1,
        periodTypeId: 1,
        periodDate: new Date().toISOString(),
        periodBegin: '',
        periodEnd: '',
        comment: '',
        usageTypeId: this.$store.state.empScheduleLookups.usageTypes.length == 0 ? 0 : this.$store.state.empScheduleLookups.usageTypes[0].value,
        rateTypeId: this.$store.state.empScheduleLookups.rateTypes.length == 0 ? 0 : this.$store.state.empScheduleLookups.rateTypes[0].value,
        duration: 0,
        wholeDay: false

      };
      this.isNewItem = true;
      this.addingNewItem = true;
      this.wholeDay = false;
      this.perBegining = '';
      this.perEnd = '';
    },
    saveItem() {
      //error checks
      if (this.schedule.employeeId < 0) {
        this.$alertMsg(this.$t('messages.employeeNotSelected'), 3);
        return;
      }

      if (!this.wholeDay) {
        if (this.schedule.periodEnd != null && this.schedule.periodEnd != '' && this.schedule.periodBegin != null && this.schedule.periodBegin != '')
          this.calculateDuration();
        else {
          this.$alertMsg(this.$t('messages.completeStarEndTime'), 3);
          return;
        }
      }

      if (this.schedule.duration <= 0 && !this.wholeDay) {
        this.$alertMsg(this.$t('messages.wrongStarEndTime'), 3);
        return;
      }

      if (!this.schedule.usageTypeId || this.schedule.usageTypeId < 0) {
        this.$alertMsg(this.$t('schedule.usageTypeError'), 3);
        return;
      }

      if (!this.schedule.rateTypeId || this.schedule.rateTypeId < 0) {
        this.$alertMsg(this.$t('schedule.rateTypeError'), 3);
        return;
      }

      //add rateHours
      this.schedule['rateHours'] = this.$store.state.empScheduleLookups.employees.filter(e => e.employeeId == this.schedule.employeeId)[0].rateHours[parseInt(this.schedule.rateTypeId)];

      axios.post('/Schedule/InsertOrUpdateEmployeeSchedule', this.schedule)
        .then(response => {
          this.getEmployeeSchedules();
          this.$alertMsg(this.$t('messages.employeeSchedSaved'), 2);
        })
        .catch(error => {
          this.$alertMsg(error);
          console.log(error);
        })
    },
    deleteSchedule() {
      axios.post('/Schedule/DeleteEmployeeSchedule', { Value: this.schedule.id })
        .then(response => {
          this.getEmployeeSchedules();
        })
        .catch(error => {
          this.$alertMsg(error);
          console.log(error);
        })
    }
  }
}
